import React, { useEffect, useState } from 'react';
import { Menu, Phone, X } from 'lucide-react';
import { Logo } from './Logo';
import { business, nav } from '../data/site';
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed inset-x-0 top-0 z-50" data-id="element-105" data-mp="2wk72ahfxx5rj">
      <div className="hatch h-1.5 w-full" aria-hidden="true" data-id="element-106" data-mp="2wiw0gn622832" />
      <div className={`border-b border-steel-200 bg-white transition-shadow duration-300 ${scrolled ? 'shadow-[0_10px_30px_-18px_rgba(0,0,0,0.55)]' : ''}`} data-id="element-107" data-mp="31cgzmijdx83u">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-6 px-5 py-3 lg:px-10" data-id="element-108" data-mp="3bbfvf0j1x99f">
          <a href="#top" className="flex shrink-0 items-center" aria-label={business.name} data-id="element-109" data-mp="3fc9jbtwhuo2b">
            <Logo className="h-11 w-auto sm:h-14" data-id="element-110" data-mp="2wmfjaq8pxe7b" />
          </a>

          <nav aria-label="Main" className="hidden items-center gap-8 lg:flex" data-id="element-111" data-mp="2rl8aqoyr4azl">
            {nav.map(item => <a key={item.href} href={item.href} className="font-display text-[13px] font-medium uppercase tracking-[0.18em] text-steel-700 transition-colors hover:text-brand" data-id="element-112" data-mp="2mnpxwnhm5bmb">
                {item.label}
              </a>)}
          </nav>

          <div className="flex items-center gap-3" data-id="element-113" data-mp="3acre4wwotr25">
            <a href={business.phoneHref} className="hidden items-center gap-2 font-mono text-sm text-steel-950 transition-colors hover:text-brand md:flex" data-id="element-114" data-mp="35l9cs7qr5ogn">
              <Phone className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-115" data-mp="1w61n64ukfua" />
              {business.phone}
            </a>
            <a href="#contact" className="hidden bg-brand px-5 py-3 font-display text-[13px] font-semibold uppercase tracking-[0.16em] text-white transition-colors hover:bg-steel-950 sm:block" data-id="element-116" data-mp="3tav7ahw6jfib">
              Get a Quote
            </a>
            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center border border-steel-300 text-steel-950 lg:hidden" data-id="element-117" data-mp="1ho1gz0c8j3zd">
              {open ? <X className="h-5 w-5" data-id="element-118" data-mp="1cpqbf1sz3fmy" /> : <Menu className="h-5 w-5" data-id="element-119" data-mp="1cq01epe0pmsn" />}
            </button>
          </div>
        </div>

        {open && <div className="border-t border-steel-200 bg-white lg:hidden" data-id="element-120" data-mp="yr8ov7et096m">
            <nav aria-label="Mobile" className="mx-auto flex max-w-[1400px] flex-col px-5 py-2" data-id="element-121" data-mp="13oikx5wp7j3f">
              {nav.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="border-b border-steel-100 py-4 font-display text-lg uppercase tracking-[0.12em] text-steel-950" data-id="element-122" data-mp="2y20127urxdof">
                  {item.label}
                </a>)}
              <a href={business.phoneHref} className="mb-4 mt-4 flex items-center justify-center gap-2 bg-brand px-5 py-4 font-display text-base font-semibold uppercase tracking-[0.14em] text-white" data-id="element-123" data-mp="w59dhi7r5uh0">
                <Phone className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="156z1ee2feba1" />
                {business.phone}
              </a>
            </nav>
          </div>}
      </div>
    </header>;
}